import { createContext, useContext, useState, useCallback } from 'react';

const AuthModalContext = createContext();

export const AuthModalProvider = ({ children }) => {
  const [modalType, setModalType] = useState(null);

  const openModal = useCallback((type) => setModalType(type), []);
  const closeModal = useCallback(() => setModalType(null), []);

  return (
    <AuthModalContext.Provider value={{ modalType, openModal, closeModal }}>
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => useContext(AuthModalContext);
